__turbopack_context__.v({
  "artCircle": "artCircle-module-scss-module__6iUAnq__artCircle",
});
